module.exports = __webpack_public_path__ + "gg.7ee2d7623226324f452f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gg.svg
// module chunks = styles